import api from 'api';

export const loadComments = api(
  'GET /api/gallery-concepts/:conceptId/comments'
);

export const createComment = api(
  'POST /api/gallery-concepts/:conceptId/comments'
);

export const updateComment = api(
  'PUT /api/gallery-concepts/:conceptId/comments'
);

export const removeComment = api(
  'DELETE /api/gallery-concepts/:conceptId/comments/:id'
);
